function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AccordionBlock = /*#__PURE__*/function () {
  function AccordionBlock() {
    _classCallCheck(this, AccordionBlock);
    this.classes = {
      item: 'accordion',
      active: 'accordion--active',
      toggle: 'accordion__toggle'
    };
    this.items = Array.from(document.getElementsByClassName(this.classes.item));
    this.toggles = Array.from(document.getElementsByClassName(this.classes.toggle));
    if (!this.toggles || this.toggles.length == 0) return false;
    this.bindEventHandlers();
  }
  return _createClass(AccordionBlock, [{
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      var _this = this;
      this.toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
          return _this.toggleItem(e);
        });
      });
    }
  }, {
    key: "toggleItem",
    value: function toggleItem(e) {
      var _this2 = this;
      var item = e.target.parentNode;
      if (item.classList.contains(this.classes.active)) {
        item.classList.remove(this.classes.active);
      } else {
        this.items.forEach(function (i) {
          return i.classList.remove(_this2.classes.active);
        });
        item.classList.add(this.classes.active);
      }
    }
  }]);
}();
export { AccordionBlock as default };